import {App} from '@gl/app/lit/lib/app.js';
import {routes} from './routes/index.js';
import {ignite} from '@gl/app/kiln/index.js';
import {FlywheelComponent} from '@gl/app/lit/lib/component.js';
import {NewRelic} from '@gl/app/lit/lib/new_relic.js';
import {initDataDog} from '@gl/app/lib/datadog.js';
import {isDev} from '@gl/app/utils/general.js';
import {createStylesheetManager} from '@gl/app/core/stylesheet_manager.js';

import 'normalize.css/normalize.css';
import '@gl/app/lit/common/styles/app.scss';
import '@gl/app/ui/global.scss';
import '@gl/app/styles/app.scss';
import '@gl/app/core/root.js';

// Create an async split point for the theme definition
import('@gl/app/ui/design_system/theme.css.js');

const app = new App({
  name: 'VortexFrontend',
  routes,
});

if (isDev) {
  // Enable HMR for Flywheel components.
  import('@gl/app/utils/hmr.js');
}

// Initialize stylesheet manager for adoptedStyleSheets
const stylesheetManager = createStylesheetManager();

if (
  new URLSearchParams(window.location.search).has('perf') ||
  localStorage.getItem('gl:perf')
) {
  import('@gl/next/features/performance/init.js').then(({init}) => {
    init();
  });
}

app.init();

addEventListener('DOMContentLoaded', () => {
  stylesheetManager.init();

  // Initiates Kiln.
  ignite(FlywheelComponent.tagRegistry);
  // Instantiates NewRelic's browser agent.
  NewRelic.init();
  // Initializes Datadog RUM
  initDataDog();
});

if (module.hot) {
  module.hot.accept();
}
